/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Sample_BodyInputs */

const ja_playdata_home_sample_body = /** @type {(inputs: Playdata_Home_Sample_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントサマリー、視聴者数の推移、時間帯別視聴者数、競合チャンネル分析、チャンネル別累計視聴時間、ゲーム別の競合分析を収録しています。`)
};

const en_playdata_home_sample_body = /** @type {(inputs: Playdata_Home_Sample_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event summary, viewers over time, viewers by time of day, competitive channel analysis, cumulative viewing time by channel, and competitive analysis by game.`)
};

/**
* | output |
* | --- |
* | "Event summary, viewers over time, viewers by time of day, competitive channel analysis, cumulative viewing time by channel, and competitive analysis by game." |
*
* @param {Playdata_Home_Sample_BodyInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_sample_body = /** @type {((inputs?: Playdata_Home_Sample_BodyInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Sample_BodyInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_sample_body(inputs)
	return en_playdata_home_sample_body(inputs)
});